export interface SpringPaginationResult<T> {
  content?: T[] // 임시
  contents: T[]
  pageable: {
    sort: {
      sorted: boolean
      unsorted: boolean
      empty: boolean
    }
    offset: number
    pageNumber: number
    pageSize: number
    paged: boolean
    unpaged: boolean
  }
  last: boolean
  totalPages: number
  totalElements: number
  sort: {
    sorted: boolean
    unsorted: boolean
    empty: boolean
  }
  first: boolean
  size: number
  number: number
  numberOfElements: number
  empty: boolean
}

export interface Pagination {
  pageIndex: number
  pageSize: number
  pageSorts: {
    pageSortField: PageSortField
    pageSortOrder: PageSortOrder
  }[]
}

export enum PageSortField {
  IDENTIFIER = 'IDENTIFIER',
  CREATED_DATE = 'CREATED_DATE',
  UPDATED_DATE = 'UPDATED_DATE',
  PUBLISHED_DATE = 'PUBLISHED_DATE',
  CONTENTS_RATING = 'CONTENTS_RATING',
  createdTime = 'createdTime',
  updatedTime = 'updatedTime',
  id = 'id',
  thumbUpCount = 'thumbUpCount',
  commentCount = 'commentCount',
  viewCount = 'viewCount',
}

export enum PageSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
